import { Box, Typography } from "@mui/material";
import React from "react";
import CardServiceProvider from "./CardServiceProvider";

const SelectServiceProvider = ({ listServiceProviders }) => {
  // console.log("Lista de prestadores se servicio", listServiceProviders);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        width: "100%",
        paddingLeft: 4,
        paddingRight: 4,
        gap: 4,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyItems: "center",
          flexWrap: "wrap",
          gap: 3,
          justifyContent: { xs: "center", sm: "flex-center" },
        }}
      >
        {listServiceProviders ? (
          listServiceProviders.map((provider) => (
            <Box
              key={provider?._id}
              sx={{
                width: { xs: "100%", sm: "48%", md: "30%", lg: "23%" },
                minWidth: { xs: "100%", sm: 300 },
              }}
            >
              <CardServiceProvider serviceProvider={provider} />
            </Box>
          ))
        ) : (
          <Typography>No hay profesionales disponibles.</Typography>
        )}
      </Box>
    </Box>
  );
};

export default SelectServiceProvider;
